import ContentBox from 'components/ContentBox'
import { GetAppButton } from 'components/DownloadButton'
import TextBody from 'components/TextBody'
import TextTitleCondensed from 'components/TextTitleCondensed'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import { isMobileScreenViewportSelect } from 'modules/viewport/selectors'
import PropTypes from 'prop-types'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { SubscriptionFreePlanFeatures } from 'pages/Premium/FreeVsPremiumFeatures/SubscriptionPlans/Free/Features/index.js'
import TextBodySmaller from 'components/TextBodySmaller.js'
import { shouldShowNewCustomerDiscountUserSelect } from 'modules/training/modules/training-users/selectors/shouldShowNewCustomerDiscount/index.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen/index.js'
import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current'
import ButtonPrimary from 'components/ButtonPrimary/index.js'
import logEventAnalyticsUtil from 'modules/analytics/utils/log-event/index.js'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'

const messages = defineMessages({
  joinToday: {
    id: 'SubscriptionFreePlan.joinToday',
    defaultMessage: 'Always free. Join today.'
  },
  title: {
    id: 'SubscriptionFreePlan.title',
    defaultMessage: 'Free'
  },
  free: {
    id: 'SubscriptionFreePlan.free',
    defaultMessage: 'Free'
  },
  getStarted: {
    id: 'SubscriptionFreePlan.getStarted',
    defaultMessage: 'Get started'
  }
})

const ANALYTIC_EVENT = {
  FREE_PLAN_GET_STARTED: 'FREE_PLAN_GET_STARTED'
}

/**
 * @param props
 * @param props.isSummary
 * @param props.isCompact
 * @param props.areFeaturesPressable
 * @param props.isReadOnly
 * @returns {Element}
 * @constructor
 */
export function SubscriptionFreePlan (props) {
  const intl = useIntl()
  const {
    isSummary,
    areFeaturesPressable,
    isCompact
  } = props

  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const isMobileScreen = useSelector(isMobileScreenViewportSelect)
  const shouldShowNewCustomerDiscount = useSelector(shouldShowNewCustomerDiscountUserSelect)
  const currentUser = useSelector(getCurrentTrainingUserSelect)

  const handleGetStartedClick = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.FREE_PLAN_GET_STARTED)
  }

  const style = {}

  if (isMobileScreen) {
    style.width = 'calc(100vw - 5rem)'
  } else {
    style.width = '18em'
  }

  return (
    <ContentBox
      pt={isCompact ? 2 : 3}
      mb={0}
      style={style}
      bd={isCompact}
    >
      <View
        style={{
          width: '100%',
          height: '100%',
          justifyContent: View.JUSTIFY.CENTER,
          alignItems: isSummary
            ? View.ALIGN.START
            : View.ALIGN.CENTER
        }}
      >
        <h3 style={{ height: '1.7em' }}>
          <TextTitleCondensed style={{
            display: 'inline-block',
            height: '100%'
          }}
          >
            {formatMessageIntlUtil(intl, messages.title)}
          </TextTitleCondensed>
        </h3>

        {
          !isCompact && (
            <SubscriptionFreePlanFeatures
              isSummary={isSummary}
              areFeaturesPressable={areFeaturesPressable}
            />
          )
        }

        {
          !!shouldShowNewCustomerDiscount &&
          !isSummary &&
          !isSmallScreen && (
            <View style={{
              height: '18px'
            }}
            />
          )
        }

        {
          !isCompact && (
            <TextBody
              mt={2}
              b
            >
              {formatMessageIntlUtil(intl, messages.free)}
            </TextBody>
          )
        }

        <View>
          <TextBodySmaller c='paragraph'>
            {formatMessageIntlUtil(intl, messages.joinToday)}
          </TextBodySmaller>
        </View>

        {
          !!shouldShowNewCustomerDiscount &&
          !isSummary &&
          !isSmallScreen && (
            <View style={{
              height: '16.5px'
            }}
            />
          )
        }

        {
          !isSummary && (
            <div
              style={{
                height: isMobileScreen ? '42px' : '50px',
                width: '100%',
                marginTop: STYLES_MARGIN.SMALL
              }}
            >
              {
                currentUser
                  ? (
                    <div>
                      <GetAppButton
                        row
                      />
                    </div>
                    )
                  : (
                    <ButtonPrimary
                      url={`${ROUTE_PATH.ACCOUNT}?openLogin=true`}
                      onClick={handleGetStartedClick}
                      style={{
                        width: '100%'
                      }}
                    >
                      {formatMessageIntlUtil(intl, messages.getStarted)}
                    </ButtonPrimary>
                    )
              }
            </div>
          )
        }
      </View>
    </ContentBox>
  )
}

SubscriptionFreePlan.propTypes = {
  isReadOnly: PropTypes.bool,
  isSummary: PropTypes.bool
}
